export type BdVirtualClinicAdmissionCause =
  | 'E'
  | 'Z'
  | 'N'
  | 'R'
  | 'V'
  | 'A'
  | 'G'
  | 'B';

const ADMISSION_CAUSE_DISPLAY_NAMES = {
  E: 'Einweisung durch den Arzt',
  Z: 'Einweisung durch den Zahnarzt',
  N: 'Notfall',
  R: 'Aufnahme nach vorausgehender Behandlung in einer Rehabilitationseinrichtung',
  V: 'Verlegung mit Behandlungsdauer im verlegenden Krankenhaus laenger als 24 Stunden',
  A: 'Verlegung mit Behandlungsdauer im verlegenden Krankenhaus bis zu 24 Stunden',
  G: 'Geburt',
  B: 'Begleitperson',
} as const;

export const BD_VIRTUAL_CLINIC_ADMISSION_CAUSE_DISPLAY_NAMES: {
  [admissionCause in BdVirtualClinicAdmissionCause]: string;
} = ADMISSION_CAUSE_DISPLAY_NAMES;

export type AdmissionCauseDisplayName =
  (typeof ADMISSION_CAUSE_DISPLAY_NAMES)[keyof typeof ADMISSION_CAUSE_DISPLAY_NAMES];
